import api from "api/api";
import { openModalConfirm } from "components/modal-confirm-new";
import { Toast } from "components/toast";
import { User } from "contexts/types/application-context-types";
import { SelectedCustomer } from "pages/carteira";

export function handleCashback({
  cashbackButtonLabel,
  setSelectedCustomer,
  user,
  selectedCustomer,
}: {
  cashbackButtonLabel: "Desativar Cashback" | "Ativar Cashback" | null;
  user: User;
  setSelectedCustomer: React.Dispatch<React.SetStateAction<SelectedCustomer>>;
  selectedCustomer: SelectedCustomer;
}) {
  if (cashbackButtonLabel === "Ativar Cashback") {
    openModalConfirm({
      message: "Deseja solicitar a ativação do cashback?",
      onConfirm: async () => {
        try {
          const { data } = await api.get(
            `/customers/${selectedCustomer.id}/change-cashback?status=PENDING`
          );
          Toast({ title: "Cashback Solicitado" });
          setSelectedCustomer({
            ...selectedCustomer,
            cashback: "PENDING",
          });
        } catch (e) {
          Toast({ title: "Erro ao solicitar cashback" });
        }
      },
      confirmButtonStyle: { variant: undefined },
    });
  } else if (cashbackButtonLabel === "Desativar Cashback") {
    openModalConfirm({
      message: "Deseja desativar o cashback?",
      onConfirm: async () => {
        try {
          const { data } = await api.get(
            `/customers/${user.userData.customerId}/change-cashback?status=DISABLED`
          );
          Toast({ title: "Cashback Desativado" });
          setSelectedCustomer({
            ...selectedCustomer,
            cashback: "DISABLED",
          });
        } catch (e) {
          Toast({ title: "Erro ao desativar cashback" });
        }
      },
    });
  }
}
